module.exports = __webpack_public_path__ + "static/media/cities.66432c14.png";